import React from 'react'
import PropTypes from 'prop-types'
import { FormattedMessage } from 'react-intl'
import { getCouponDiscount } from 'winearound-shared/utils/coupons'

class EventPaymentInstructions extends React.Component {
  constructor(props) {
    super(props)

    this.state = { expandCancellation: true }
  }

  static createParagraph(translation, values = {}) {
    return (
      <p key={translation}>
        <FormattedMessage
          id={translation}
          values={values}
        />
      </p>
    )
  }

  render() {
    const {
      payment,
      price,
      priceMode,
      guests,
      eventExtras,
      currency,
      coupon,
      reservationExtras,
      paymentDisabled,
      customPaymentText,
      customProductText,
    } = this.props

    if (!this.props.payment || !this.props.guests) {
      return null
    }

    const { expandCancellation } = this.state
    const block = []
    let total = priceMode === 'event'
      ? price
      : price * guests
    const paymentEnabled = payment.enabled && !paymentDisabled

    block.push(
      <b key="payment_instructions-title" className="reservation-instructions__subtitle">
        <FormattedMessage
          id="app.event.reservation.instructions.payment.title"
        />
      </b>
    )

    if (priceMode === 'on_request') {
      block.push(
        EventPaymentInstructions.
          createParagraph('app.event.reservation.instructions.payment.on-request')
      )

      return (<div>{block}</div>)
    }

    if (!paymentEnabled) {
      if (customPaymentText) {
        block.push(
          EventPaymentInstructions.
            createParagraph(customPaymentText)
        )
      } else {
        block.push(
          EventPaymentInstructions.
            createParagraph('app.event.reservation.instructions.payment.no-cc.description')
        )
      }
    } else {
      block.push(
        EventPaymentInstructions.
          createParagraph('app.event.reservation.instructions.payment.cc.description')
      )
    }
    block.push(<br key="space-payment" />)

    if (priceMode === 'event') {
      block.push(
        <i key={'guests'}>
          {
            EventPaymentInstructions.
              createParagraph('app.event.reservation.payment.event', {
                price: price.toFixed(2),
                currency,
              })
          }
        </i>
      )
    } else {
      block.push(
        <i key={'guests'}>
          {
            EventPaymentInstructions.
              createParagraph(`app.event.reservation.payment.${customProductText ? 'custom' : 'guests'}`, {
                price: price.toFixed(2),
                quantity: guests,
                customText: customProductText,
                currency,
              })
          }
        </i>
      )

    }
    for (const extraId in reservationExtras) { // eslint-disable-line guard-for-in
      const { label, price: extraPrice } = eventExtras.find(({ id }) => id === extraId)
      const quantity = reservationExtras[extraId]
      if (quantity === 0 || quantity === '0') {
        continue
      }
      block.push(
        <i key={`extra-${extraId}`}>
          {
            EventPaymentInstructions.
              createParagraph('app.event.reservation.payment.extra', {
                label,
                price: extraPrice.toFixed(2),
                quantity,
                currency,
              })
          }
        </i>
      )
      total += quantity * extraPrice
    }

    const { amount, off, left } = getCouponDiscount(
      coupon ? coupon.coupon : {},
      { price, guests, total }
    )

    if (off) {
      block.push(
        <i key="discount">
          {
            EventPaymentInstructions.
              createParagraph('app.event.reservation.payment.discount', {
                off: off.toFixed(2),
                currency,
              })
          }
        </i>
      )
      block.push(<br key="space-discount" />)
    }
    block.push(
      <u key="total" style={{ fontSize: '125%' }}><i>
        {
          EventPaymentInstructions.
            createParagraph('app.event.reservation.payment.total', {
              total: amount.toFixed(2),
              currency,
            })
        }
      </i></u>
    )
    if (payment.limit && paymentEnabled) {
      block.push(
        <i key="limit">
          {
            EventPaymentInstructions.
              createParagraph('app.event.reservation.payment.limit', {
                max_amount: payment.max_amount.toFixed(2),
                currency,
              })
          }
        </i>
      )
    }
    if (payment.amounts[0] !== 1 && paymentEnabled) {
      block.push(
        EventPaymentInstructions.
          createParagraph('app.event.reservation.payment.phase-0.partial', {
            amount: payment.amounts[0],
            total: (amount * payment.amounts[0]).toFixed(2),
            currency,
          })
      )
    }
    if (left && coupon.coupon.remaining === 'spendable') {
      block.push(
        <i key="remaining">
          {
            EventPaymentInstructions.
              createParagraph('app.event.reservation.payment.remaining', {
                left: left.toFixed(2),
                currency,
              })
          }
        </i>
      )
    }
    // block.push(<br key="space-3" />);

    if (paymentEnabled) {
      const expandFunction = () =>
        this.setState({ expandCancellation: !expandCancellation })
      const caretIcon = `icon icon--large ${
        expandCancellation ? 'icon--arrow-up' : 'icon--arrow-down'
      }`
      block.push(
        <b
          key="payment_instructions-refunds"
          className="reservation-instructions__subtitle"
          onClick={expandFunction.bind(this)}
          style={{ cursor: 'pointer' }}
        >
          <FormattedMessage
            id="app.event.reservation.refunds.title"
          />
          <i className={caretIcon} style={{ position: 'relative', top: '2px' }}></i>
        </b>
      )
      if (!expandCancellation) {
        return (<div>{block}</div>)
      }

      const refunds = payment.refundable
        ? payment.refunds
        : [0, 0]
      const firstAmount = payment.refundable
        ? amount * payment.amounts[0] * refunds[0]
        : 0
      const secondAmount = payment.refundable
        ? amount * payment.amounts[0] * refunds[1]
        : 0

      if (refunds[0] === 0 && refunds[1] === 0) {
        block.push(
          EventPaymentInstructions.
            createParagraph('app.event.reservation.refunds.not-refundable', {})
        )
      } else {
        if (refunds[0] === 1) {
          block.push(
            EventPaymentInstructions.
              createParagraph('app.event.reservation.refunds.phase-0.whole', {
                days: payment.hours / 24,
                total: firstAmount.toFixed(2),
                currency,
              })
          )
        } else {
          block.push(
            EventPaymentInstructions.
              createParagraph('app.event.reservation.refunds.phase-0.partial', {
                refund: refunds[0],
                days: payment.hours / 24,
                total: firstAmount.toFixed(2),
                currency,
              })
          )
        }
        block.push(<br key="space-4" />)
        if (refunds[1] === 1) {
          block.push(
            EventPaymentInstructions.
              createParagraph('app.event.reservation.refunds.phase-1.whole', {
                days: payment.hours / 24,
                total: secondAmount.toFixed(2),
                currency,
              })
          )
        } else {
          block.push(
            EventPaymentInstructions.
              createParagraph('app.event.reservation.refunds.phase-1.partial', {
                refund: refunds[1],
                days: payment.hours / 24,
                total: secondAmount.toFixed(2),
                currency,
              })
          )
        }
      }
      // block.push(<br key="space-5" />);
    }

    return (<div>{block}</div>)
  }
}

EventPaymentInstructions.propTypes = {
  payment: PropTypes.object.isRequired,
  price: PropTypes.number.isRequired,
  priceMode: PropTypes.string.isRequired,
  eventExtras: PropTypes.array,
  currency: PropTypes.string.isRequired,
  guests: PropTypes.number.isRequired,
  coupon: PropTypes.object,
  reservationExtras: PropTypes.object,
  paymentDisabled: PropTypes.bool.isRequired,
  customPaymentText: PropTypes.string.isRequired,
  customProductText: PropTypes.string.isRequired,
}

export default EventPaymentInstructions
